
const API_LOADING_STATUS = 5;
const API_READY_STATUS = 10;


export  {
    API_LOADING_STATUS,
    API_READY_STATUS
};